import useTranslation from 'next-translate/useTranslation';

import type { FullContest } from '~/domains/contest/domains/services/interfaces/full-contest.interface';
import { getCdnUrl } from '~/domains/assets/utils/getCdnUrl';

import { PromoCalloutRow } from './PromoCalloutRow';
import { useContestDetailPromoCards } from './useContestDetailPromoCards';
import { useStyles } from './PromoCallouts.styles';

interface PromoCalloutsProps {
  contestData: FullContest;
}

export function PromoCallouts({ contestData }: PromoCalloutsProps) {
  const { classes } = useStyles();
  const { t } = useTranslation('contest');
  const { showSplitEntry, showMarketplace, openSplitEntryModal, openMarketplaceModal } =
    useContestDetailPromoCards(contestData);

  if (!showSplitEntry && !showMarketplace) {
    return null;
  }

  return (
    <div className={classes.card}>
      {showSplitEntry && (
        <PromoCalloutRow
          icon={getCdnUrl('/images/promo/contest-detail-split-entry-logo.png')}
          title={t('detail.promoCallouts.splitEntry.title')}
          availableLabel={t('detail.promoCallouts.splitEntry.available')}
          subtitle={t('detail.promoCallouts.splitEntry.subtitle')}
          learnMoreLabel={t('detail.promoCallouts.learnMore')}
          onOpen={openSplitEntryModal}
          dataTestId="contest-detail-promo-callout-split-entry"
        />
      )}
      {showSplitEntry && showMarketplace && <div className={classes.divider} />}
      {showMarketplace && (
        <PromoCalloutRow
          icon={getCdnUrl('/images/promo/contest-detail-marketplace-logo.png')}
          title={t('detail.promoCallouts.marketplace.title')}
          availableLabel={t('detail.promoCallouts.marketplace.available')}
          subtitle={t('detail.promoCallouts.marketplace.subtitle')}
          learnMoreLabel={t('detail.promoCallouts.learnMore')}
          onOpen={openMarketplaceModal}
          dataTestId="contest-detail-promo-callout-marketplace"
        />
      )}
    </div>
  );
}

export default PromoCallouts;
